import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const REMOVE_DATA_SOURCE = registerQuery({
  fieldName: 'removeDataSource',
  args: ['flowId', 'dataSourceId'],
  fetcher: ({
    flowId,
    dataSourceId
  }) => {
    return http.delete(`automationplatform/v1/data-sources/flows/${flowId}/${dataSourceId}`);
  }
});